import { Box, HStack, IconButton } from '~/design_system'
import { useMsg } from '~/common/localizationUtils'
import { History, Maximize2, Minimize2, X } from '~/assistant/icons'

type ThreadHeaderProps = {
  onClose?: () => void
  isExpanded?: boolean
  onToggleExpand?: () => void
  onShowHistory?: () => void
}

export const ThreadHeader = ({ onClose, isExpanded, onToggleExpand, onShowHistory }: ThreadHeaderProps) => {
  const msg = useMsg()

  return (
    <Box
      px={4}
      py={3}
      borderBottom="1px solid"
      borderColor="gray.200"
      display="flex"
      alignItems="center"
      justifyContent="space-between">
      {onShowHistory && (
        <IconButton
          aria-label={msg('assistant.ai.history.title')}
          icon={<History />}
          onClick={onShowHistory}
          variant="ghost"
          size="sm"
          isRound
          showTooltip
        />
      )}
      <HStack spacing={2} ml="auto">
        <IconButton
          aria-label={isExpanded ? msg('common.ui.collapse') : msg('common.ui.expand')}
          icon={isExpanded ? <Minimize2 /> : <Maximize2 />}
          onClick={onToggleExpand}
          variant="ghost"
          size="sm"
          isRound
          showTooltip
        />
        <IconButton
          aria-label={msg('common.ui.close')}
          icon={<X />}
          onClick={onClose}
          variant="ghost"
          size="sm"
          isRound
          showTooltip
        />
      </HStack>
    </Box>
  )
}
